// Copyright (c) 2023, Comsearch, Inc., All rights reserved

import { change } from 'redux-form'

const handleRadioFieldToggle = (event, sourceForm) => (dispatch, getState) => {
  const { value } = event.target

  const {
    radioCode,
    radioCompanyId,
  } = getState().form [sourceForm].initial

  // update field type
  dispatch(change(sourceForm, 'radioField', value))
  // reset to initial values
  dispatch(change(sourceForm, 'radioCode', radioCode))
  dispatch(change(sourceForm, 'radioCompanyId', radioCompanyId))
}

export default handleRadioFieldToggle